import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark} from "@fortawesome/free-solid-svg-icons";
import {useErrorTranslation} from "../../api/utilities/translateErrorMessage.js";
import {useEffect, useState} from "react";

export function translateCurrentError(error, translateError, setErrorMessage) {
    let active = true;

    const translate = async () => {
        try {
            const message = await translateError(error);
            if (active) {
                setErrorMessage(message);
            }
        } catch {
            if (active) {
                setErrorMessage('');
            }
        }
    };
    void translate();

    return () => {
        active = false;
    };
}

/**
 * Error can be text, or error object...
 */
export default function FormError({error, message, title, className = '', variant = 'inline', footer = null}) {

    const {et} = useErrorTranslation();
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (message) {
            setErrorMessage('');
            return undefined;
        }
        setErrorMessage('');
        return translateCurrentError(error, et, setErrorMessage);
    }, [error, message]);

    const displayedErrorMessage = message || errorMessage;
    if (((error === null || error === undefined) && !message) || displayedErrorMessage === '') {
        return null;
    }

    if (variant === 'card') {
        return (
            <section role="alert" className={`w-full overflow-hidden rounded-3xl border border-white/15 bg-white text-slate-700 shadow-2xl shadow-slate-950/40 ${className}`}>
                <div className="flex gap-4 px-5 py-6 sm:px-8 sm:py-7">
                    <div className="flex size-10 shrink-0 items-center justify-center rounded-2xl bg-rose-50 text-rose-600">
                        <FontAwesomeIcon icon={faCircleXmark}/>
                    </div>
                    <div className="min-w-0">
                        {title && <h2 className="text-xs font-bold uppercase tracking-[0.16em] text-rose-600">{title}</h2>}
                        <p className={`${title ? 'mt-2' : ''} text-sm leading-6 text-slate-700`}>{displayedErrorMessage}</p>
                    </div>
                </div>
                {footer && <div className="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-5 sm:flex-row sm:items-center sm:justify-end sm:px-8">
                    {footer}
                </div>}
            </section>
        );
    }

    return (
        <div role="alert"
             className={
                 "w-full mb-6 bg-rose-100 rounded-md dark:bg-rose-400/30 dark:border-transparent border text-rose-600 dark:text-rose-400 border-rose-200"
                 + ' ' + className
             }
        >
            <div className="inline-flex px-4 py-2  text-sm">
                <div className="flex w-full justify-between items-start">
                    <div className="flex gap-2">
                        <div><FontAwesomeIcon icon={faCircleXmark}/></div>
                        <div>{displayedErrorMessage}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
